import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


export enum TicketStatusType {
	OPEN = 1,
	ANSWERD = 2,
	CUSTOMER_REPLY = 3,
	ON_HOLD = 4,
	IN_PROGRESS = 5,
	CLOSED = 6,
	TC_CONTACT = 7,
	ARCHIVED = 8
}

export namespace TicketStatusType {

	export function getTitle(type: TicketStatusType): string {
		return Object.keys(TicketStatusType).find(key => TicketStatusType[key] === type);
	}

}


@Pipe({
	name: 'ticketStatusTypeText',
	standalone: true
})
export class TicketStatusTypeTextPipe implements PipeTransform {

	constructor(private translateService: TranslateService) {
	}

	ticketStatusType = TicketStatusType;
	translatedText: string;

	transform(value: TicketStatusType): any {
		this.getTranslate(
			this.ticketStatusType.getTitle(value)
		);

		return this.translatedText;
	}

	async getTranslate(text: string) {
		text = 'ENUM.TICKET_STATUS.' + text;
		const m = await this.translateService.get(text).subscribe(
			res => {
				this.translatedText = res;
			}
		);
	}
}
